(function () {
    'use strict';
    angular.module('Const').constant('RefStatusesConst', {
        refStatus: {
            tax: {
                private: 'Private'
            },
            booking: {
                new: 'New',
                pending: 'Awaiting Booking',
                unprocessed: 'Unprocessed',
                inprogress: 'Processing',
                processed: 'Completed'
            },
            tracking: {
                documentationprepared: 'Documentation Prepared',
                bookingarranged: 'Booking Arranged',
                collected: 'Collected',
                intransit: 'In Transit',
                arrivedatdestination: 'Arrived At Destination',
                outfordelivery: 'Out For Delivery',
                delivered: 'Delivered'
            }
        }
    });
})();


// WEBPACK FOOTER //
// ./js/consts/refStatuses.js